import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

class HeaderSettings extends React.Component {
render() {
  return (
    <div>
      Header Settings Tab
    </div>
  );
}
}

export var mapStateToProps = (state) => {
  return {

  }
}

export var mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSettings);
